import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

import { error, saveBillingInfo } from '../BillingActions';
import BillingInfoForm from '../../Subscribe/components/BillingInfoForm';

import saveIcon from '../../../assets/img/save.svg';

// Import Style
import '../Billing.scss';

class BillingInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      model: {}
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data && this.props.data.customer.billing_address) {
      this.setState({
        model: {
          firstName: this.props.data.customer.billing_address.first_name,
          lastName: this.props.data.customer.billing_address.last_name,
          country: this.props.data.customer.billing_address.country,
          state: this.props.data.customer.billing_address.state,
          vat: this.props.data.customer.vat_number,
          company: this.props.data.customer.billing_address.company,
          city: this.props.data.customer.billing_address.city,
          address: this.props.data.customer.billing_address.line1,
          zip: this.props.data.customer.billing_address.zip,
          billingEmails: this.props.data.billingEmails
        }
      });
    }
  }

  handleChange(model) {
    this.setState({ model });
  }

  handleSave() {
    if (this.validate()) {
      this.props.save(this.state.model);
    }
  }

  validate() {
    if (!this.state.model.firstName) {
      this.props.setError('First name is required');
      return false;
    }
    if (!this.state.model.lastName) {
      this.props.setError('Last name is required');
      return false;
    }
    if (!this.state.model.country) {
      this.props.setError('Country is required');
      return false;
    }
    if (!this.state.model.city) {
      this.props.setError('City is required');
      return false;
    }
    if (!this.state.model.address) {
      this.props.setError('Address is required');
      return false;
    }
    if (this.state.model.address.length > 50) {
      this.props.setError('Address must be less than 50 characters');
      return false;
    }
    if (!this.state.model.billingEmails) {
      this.props.setError('Billing email is required');
      return false;
    }

    return true;
  }

  render() {
    const { loading } = this.props;
    const { model } = this.state;

    return (
      <div className="white_box_details">
        <h3>Billing information</h3>
        <BillingInfoForm model={model} onChange={this.handleChange}></BillingInfoForm>
        <Button className='btn-ml-auto' onClick={this.handleSave}>
          <img src={saveIcon} alt="" />
          {loading ? 'Loading...' : 'Save changes'}
        </Button>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setError: err => dispatch(error(err)),
    save: model => dispatch(saveBillingInfo(model))
  };
};

function mapStateToProps(state) {
  return {
    loading: state.billing.updatingBilling
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingInfo);
